/** Shared external links — keep one source of truth so blog slugs swap in one place. */
export const BLOG_URL = 'https://www.tone3000.com/blog';
export const LISTENING_TEST_BLOG_URL = 'https://www.tone3000.com/blog/nam-a2-listening-test';
export const A2_BLOG_URL =
  'https://www.tone3000.com/blog/introducing-neural-amp-modeler-nam-architecture-2-a2';
export const A2_BLOG_TITLE = 'Introducing Neural Amp Modeler (NAM) Architecture 2 (A2)';
